import React, { useEffect, useState } from 'react';
import NumericInput from '../FormControls/NumericInput';
import { useInjection } from 'inversify-react';
import { STANDING_TICKETS_MODULE_IDS } from '../../../lib/widget_announcements/standingTickets/standingTickets.const';
import { IStandingTicketController } from '../../../lib/widget_announcements/standingTickets/standingTicket.interface';
import type { IStandingTicketsEvents } from '../../../lib/widget_announcements/standingTickets/standingTickets.events';

export const StandingTicketInput = (props) => {
  const { data } = props;
  const [count, setCount] = useState(data.selectedCount || 0);
  const standingTicketsController: IStandingTicketController = useInjection(
    STANDING_TICKETS_MODULE_IDS.STANDING_TICKETS_CONTROLLER,
  );
  const standingTicketsEvents: IStandingTicketsEvents = useInjection(
    STANDING_TICKETS_MODULE_IDS.STANDING_TICKETS_EVENTS,
  );

  const resetCount = (ticket) => {
    if (ticket.id === data.id) {
      setCount(0);
    }
  };

  useEffect(() => {
    standingTicketsController.addListener(standingTicketsEvents.REMOVE_TICKET, resetCount);

    return () => {
      standingTicketsController.removeListener(standingTicketsEvents.REMOVE_TICKET, resetCount);
    };
  }, []);

  const updateCount = (_, count) => {
    setCount(count);

    if (count === 0) {
      return standingTicketsController.removeTicket(data);
    }

    return standingTicketsController.addTicket(data, count);
  };

  return <NumericInput min={0} max={data.count} onChange={updateCount} value={count} isMobile />;
};
